
import * as THREE from 'three';
//export const Convery=singleConvery
import { TweenLite,TweenMax } from "gsap";

//站台的速度配置
var speed_config={
    "1046":0.5,
    "1047":0.5,
    "1048":0.5,
    "1050":0.5,
    "1052":0.5,
    "1053":0.5,
    "1054":0.5,
    "1056":0.5,
    "1075":0.5,
    "1076":0.5,
    "1079":0.5,
    "1080":0.5,
    "1081":0.5,
    "1082":0.5,
    "1083":0.5,
    "1084":0.5,
    "1085":0.5,
    "1086":0.5,
    "1087":0.5,
    "1088":0.5,
    "1089":0.5,
    "1090":0.5,
    "1091":0.5,
    "1092":0.5,
    "1093":0.5,
    "1094":0.5,
    "1095":0.5,
    "1096":0.5,
    "1097":0.5,
    "1098":0.5,
    "1099":0.5,
    "1100":0.5,
    "1101":0.5,
    "1102":0.5,
    "1103":0.5,
    "1104":0.5,
    "1105":0.5,
    "1106":0.5,
    "1107":0.5,
    "1037":0.5,
    "1038":0.5,
    "1039":0.5,
    "1040":0.5,
    "1041":0.5,
    "1045":0.5,
    "1027":0.5,
    "1028":0.5,
    "1029":0.5,
    "1030":0.5,
    "1032":0.5,
    "1036":0.5



}

//站台的运动方向配置    1 forward:X--,2 backward:X++,3 left:Z--,4 right:Z++,5 up:Y++,6 down:Y--
var Direction_config={
    "1046":2,
    "1047":2,
    "1048":2,
    "1050":2,
    "1052":2,
    "1053":2,
    "1054":2,
    "1056":2,
    "1075":2,
    "1076":2,
    "1079":1,
    "1080":1,
    "1081":4,
    "1082":4,
    "1083":4,
    "1084":4,
    "1085":4,
    "1086":4,
    "1087":4,
    "1088":2,
    "1089":2,
    "1090":4,
    "1091":4,
    "1092":4,
    "1093":4,
    "1094":4,
    "1095":4,
    "1096":4,
    "1097":2,
    "1098":2,
    "1099":2,
    "1100":2,
    "1101":4,
    "1102":4,
    "1103":4,
    "1104":4,
    "1105":4,
    "1106":4,
    "1107":4,
    "1037":2,
    "1038":2,
    "1039":2,
    "1040":4,
    "1041":4,
    "1045":4,
    "1027":2,
    "1028":2,
    "1029":2,
    "1030":4,
    "1032":4,
    "1036":4
 


    

}

export const Convery=function(scene,name){
    this.obj=scene.getObjectByName(name)
    this.speed=speed_config[name]
    this.box=null
    this.isroll=null
    this.dir=Direction_config[name]
   
    this.translate=function(){
        if(this.box!=null&&this.box.name=="liaoxiang"){
            //console.log("-------------",this.obj.name);
            if(this.isroll){
                //this.box.position.x-=0.01*this.speed;
            }
        }
        
    }


}








// WEBPACK FOOTER //
// ./src/components/xiayan/home/Convery.js